import { useState } from 'react';

import { TabsUI } from '../Interface';
import DynamicFormCreatorDynFields from './DynamicFormCreatorDynFields';
import DynamicFormCreatorTemplate from './DynamicFormCreatorTemplate';

const DynamicFormCreatorTabs = (props) => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      id: 0,
      name: 'Mezők',
      content: <DynamicFormCreatorDynFields {...props} />,
    },

    {
      id: 1,
      name: 'Sablon',
      content: <DynamicFormCreatorTemplate {...props} />,
    },
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab) => (
            <div key={tab.id} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
    </div>
  );
};

export default DynamicFormCreatorTabs;
